var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformationFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26772,18.25V16.16667a.40116.40116,0,0,0-.41666-.41667h-1.25V9.08333a.40116.40116,0,0,0-.41667-.41666H9.01772a.40114.40114,0,0,0-.41666.41666v2.08334a.40114.40114,0,0,0,.41666.41666h1.25V15.75h-1.25a.40116.40116,0,0,0-.41666.41667V18.25a.40116.40116,0,0,0,.41666.41667h5.83334a.40116.40116,0,0,0,.41666-.41667ZM13.60106,6.58333V4.5a.40118.40118,0,0,0-.41667-.41667h-2.5A.40118.40118,0,0,0,10.26772,4.5V6.58333A.40118.40118,0,0,0,10.68439,7h2.5a.40118.40118,0,0,0,.41667-.41667ZM21.93439,12a9.78227,9.78227,0,0,1-1.34115,5.01953,9.95491,9.95491,0,0,1-3.63932,3.63932A9.78227,9.78227,0,0,1,11.93439,22a9.78229,9.78229,0,0,1-5.01953-1.34115,9.95491,9.95491,0,0,1-3.63932-3.63932A9.78227,9.78227,0,0,1,1.93439,12,9.78227,9.78227,0,0,1,3.27554,6.98047,9.95491,9.95491,0,0,1,6.91486,3.34115,9.78229,9.78229,0,0,1,11.93439,2a9.78227,9.78227,0,0,1,5.01953,1.34115,9.95491,9.95491,0,0,1,3.63932,3.63932A9.78227,9.78227,0,0,1,21.93439,12Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFull);
export default __webpack_public_path__ + "static/media/information_full.277ae72a51165612602a77d21c54033e.svg";
export { ForwardRef as ReactComponent };